import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { getStoredStopId, withStoredStopId } from "./stopIds";
export function useTrackRecentStop(t0) {
  const $ = _c(5);
  const {
    isFallback,
    setRecents,
    stopId
  } = t0;
  const recordedRecentStopRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isFallback || $[1] !== setRecents || $[2] !== stopId) {
    t1 = () => {
      if (!stopId || isFallback || recordedRecentStopRef.current === stopId) {
        return;
      }
      recordedRecentStopRef.current = stopId;
      const timestamp = new Date().toISOString();
      setRecents(t3 => {
        const prevRecents = t3 === undefined ? [] : t3;
        const safeRecents = Array.isArray(prevRecents) ? prevRecents : [];
        const filteredRecents = safeRecents.filter(rec => getStoredStopId(rec) !== stopId);
        return [withStoredStopId({
          timestamp
        }, stopId), ...filteredRecents].slice(0, 15);
      });
    };
    t2 = [isFallback, setRecents, stopId];
    $[0] = isFallback;
    $[1] = setRecents;
    $[2] = stopId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}